import React, { Component, useCallback, useRef, useState  } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput ,MDBDataTable, MDBCard, MDBCardBody, MDBCardTitle,  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption , MDBIcon, MDBFormInline} from "mdbreact";
import {  MDBRow, MDBCol } from "mdbreact";

import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip , Divider } from 'antd';
import { api } from '../../api';
import Swal from 'sweetalert2'
import Webcam from "react-webcam";
import "./styles.css";
import ModaleditstatusNo from './ModaleditstatusNo';



//import WebcamImage from './../Tesst';
//import {WebcamImage} from './../Tesst';

const webcam = useRef<Webcam>(null);

const videoConstraints = {
  width: 440,
  facingMode: "environment"
};




export default class Registerroom extends Component {

    constructor(props) {
        super(props);
        this.state = {
        modal: false,
        loading:false,
        id_room:'',
        id_member :'',
        pic_idcard:'',
        numberroomck:'',
        timestart:'',
        timeend:'',
        price:'',
        Differences:0,
        sumprice:'',
        temporary:0, //ชั่วคราว
        Depositkey:0,//มัดจำกุญแจ
        tel:'-',
        radio: 1,//ประเภท
        numday: 1,//ประเภท
        numberroom:'',

        files:null,
        imageSrc:null,
        img:null,
        url:null,
        url2:null,
        confirm:false,
        sdf:null,
        filecomment2:null,
      
        }

        this.getroom = this.getroom.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onClick2 = this.onClick2.bind(this);
        this.onChangetype = this.onChangetype.bind(this);
       this.getencode = this.getencode.bind(this);
       this.handleSubmitroom = this.handleSubmitroom.bind(this);
       this.handleChange3 = this.handleChange3.bind(this);
    }


      onClick = (nr) => () => {
        this.setState({
          radio: nr,
        });
      };

      onClick2 = (nr) => () => {
        this.setState({
          numday: nr,
        });
      };


      handleChange3(event) {    this.setState({filecomment2: event.target.files[0]});  }

      Depositkey = (nr) => () => {
        this.setState({
            Depositkey: nr,
        });
      };
      
      onChangetype(value) {
        this.setState({ temporary:value})
      }

      onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
        //console.log({WebcamImage})
      }

      getroom (){
        const { id } = this.props.match.params
        api.get('lkselectroomid.php?id_room='+id)
        .then(res => {
        //  console.log(res);
        this.setState({ room: res.data,
            price: res.data[0].price,
            numberroom: res.data[0].numberroom,
            loading: false })
        }) 
      }

    
      handleSubmitroom() {
        // alert('A name was submitted: ' + this.state.value);
       setTimeout(() => {
    
          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
          datafrm.append("id_room", this.state.id_room);
          datafrm.append("id_member", this.state.id_member);
          datafrm.append("files", this.state.files);
          datafrm.append("numberroom", this.state.numberroom);
          datafrm.append("price", this.state.price);
          datafrm.append("Differences", this.state.Differences);
          datafrm.append("temporary", this.state.temporary);
          datafrm.append("Depositkey", this.state.Depositkey);
          datafrm.append("tel", this.state.tel);
          datafrm.append("numday", this.state.numday);

         

    
          api.post("lksavestayregis.php",datafrm,{
                                headers: {
                                    'content-type': 'multipart/form-data'
                                }
                            })
    
                            .then(res => {
                              //  console.warn(res);
                               // console.log("response: ", res)
                                if (res.status=== 200) {

                              Swal.fire({
                                title: 'เปิดห้องสำเร็จ',
                                icon: 'success',
                              // showCancelButton: true,
                                confirmButtonText: 'ตกลง',
                              // cancelButtonText: 'No, keep it'
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  window.location.href = '/Homelucky'
                                  this.toggle();  
                                } else if (result.isDenied) {
                                 // window.location.href = '/Homelucky'
                                  this.toggle();  
                                }
                             
                                
                              })
    
                                }else{
                                // window.location.href = '/'
                                Swal.fire({
                                  title: 'เปิดห้องไม่สำเร็จ',
                                  icon: 'success',
                                // showCancelButton: true,
                                  confirmButtonText: 'ตกลง',
                                // cancelButtonText: 'No, keep it'
                                }).then((result) => {
                                  this.toggle();  
                                  window.location.href = '/Homelucky'
                                })


                                }
    
                            })
    
                }, 1000);
    
    //window.location.href = '/adminfaculty'
    //this.props.updateat();
    //this.getExpert()
    
      }

     componentDidMount() {
        //  const { code } = this.props.id
          const { id } = this.props.match.params
          console.log(id);
          this.setState({ id_room:id})
          this.setState({ id_member:localStorage.getItem('id_member')})
          this.getroom();
          //console.log({WebcamImage})
      }

      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
      }

      getencode (){

        const files1 = this.dataURLtoFile(this.state.url,'hello');
       // console.log(files)
       this.setState({
        confirm: true,
        files:files1 ,
      });
      }





  render() {
//console.log(this.state.files)

const Camera = () => {
  const webcamRef = useRef(null);
  const [url, setUrl] = React.useState(null);

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
  //  setUrl(imageSrc);
    this.setState({
      url: imageSrc,
    });
  }, [webcamRef]);

  const onUserMedia = (e) => {
   // console.log(e);
  };

  return (
    <>
    <div className='text-center'>
      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        onUserMedia={onUserMedia}
      /><br/>
      {/* <button onClick={capturePhoto}>ถ่ายภาพ</button> */}
      <MDBBtn  color="deep-purple" className="text-center" onClick={capturePhoto}> <MDBIcon far icon="save" /> ถ่ายภาพ</MDBBtn>
      {/* <button onClick={() => setUrl(null)}>Refresh</button> */}
      {/* {url && (
        <div>
          <img src={url} alt="Screenshot" />
        </div>
      )} */}
      </div>
    </>
  );
};


//console.log(this.state.id_room);
console.log(this.state.files);
console.log(this.state.filecomment2);//เลขห้อง
// console.log(this.state.price);//ราคา
// console.log(this.state.Differences);//ราคาส่วนต่าง
// console.log(this.state.temporary);//ชั่วคราว
// console.log(this.state.Depositkey);//มัดจำกุญแจ
// console.log(this.state.tel);//มัดจำกุญแจ


    return (
        <MDBContainer fluid >
         <p className="text-right">   สวัสดี {localStorage.getItem('name')} : ผู้ใช้</p>    
        <h2 className="font-weight-bold  text-center">  ห้องเลขที่ {this.state.numberroom} </h2>
        <p className="text-right"> <ModaleditstatusNo id_room={this.state.id_room} numberroom={this.state.numberroom} /></p>
        {/* <h2 className="font-weight-bold  text-center">  ราคา {this.state.price}</h2> */}
        <MDBContainer  >
        <MDBCol md="12" className="d-flex justify-content-center">
       
       <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
            <MDBRow >
                <div >
                    {/* <Modaladdwork getwork={this.getwork}/>  */}
                </div>
              <MDBCol md="6" className="d-flex justify-content-center">
                    <MDBCardBody>
                       <MDBCardTitle className="text-center">  รายการ</MDBCardTitle>
                       <div className="mb-2">
                                      <label className="font-weight-bold"><MDBIcon icon="donate" /> ราคา</label>
                                      <input className="form-control" onChange={this.onTextChange} name="price"
                                          value={this.state.price} placeholder="" disabled />
                        </div>
                       <div className="mb-2">
                                      <label className="font-weight-bold"><MDBIcon icon="donate" /> ราคาเพิ่มเติม</label>
                                      <input className="form-control" onChange={this.onTextChange} name="Differences"
                                          value={this.state.Differences} placeholder=""  />
                        </div>
                        <div className="mb-2">
                        <label className="font-weight-bold"><MDBIcon icon="donate" /> ประเภท</label>
                             <MDBFormInline>
                                <MDBInput
                                gap
                                onClick={this.onClick(1)}
                                checked={this.state.radio === 1 ? true : false}
                                label="ค้างคืน"
                                type="radio"
                                id="radio1"
                                containerClass="mr-5"
                                />
                                <MDBInput
                                gap
                                onClick={this.onClick(2)}
                                checked={this.state.radio === 2 ? true : false}
                                label="ชั่วคราว"
                                type="radio"
                                id="radio2"
                                containerClass="mr-5"
                                />
                            </MDBFormInline>
                           
                        </div>
                        {this.state.radio === 2 ?<>
                          <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="money-check-alt" /> ประเภทชั่วคราว</label><br/>
                                <Select
                                    value={this.state.temporary}
                                    showSearch
                                    style={{ width:"100%" }}
                                    placeholder="เลือกประเภทการชำระ"
                                    optionFilterProp="children"
                                    onChange={this.onChangetype}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    onSearch={this.onSearch}
                                    filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                     
                                >
                                <option value="1">2 ซ​.ม</option>
                                <option value="2">3 ซ​.ม</option>
                              <option value="3">เข้าเช้า-ออกเย็น</option>
                                 </Select>
                            </div>
                        </> : <>
                        
                        <label className="font-weight-bold"><MDBIcon icon="donate" /> จำนวนวัน</label>
                             <MDBFormInline>
                                <MDBInput
                                gap
                                onClick={this.onClick2(1)}
                                checked={this.state.numday === 1 ? true : false}
                                label="1 วัน"
                                type="radio"
                                id="radio11"
                                containerClass="mr-5"
                                />
                                <MDBInput
                                gap
                                onClick={this.onClick2(2)}
                                checked={this.state.numday === 2 ? true : false}
                                label="2 วัน"
                                type="radio"
                                id="radio22"
                                containerClass="mr-5"
                                />
                                 <MDBInput
                                gap
                                onClick={this.onClick2(3)}
                                checked={this.state.numday === 3 ? true : false}
                                label="3 วัน"
                                type="radio"
                                id="radio3"
                                containerClass="mr-5"
                                />
                                 <MDBInput
                                gap
                                onClick={this.onClick2(4)}
                                checked={this.state.numday === 4 ? true : false}
                                label="4 วัน"
                                type="radio"
                                id="radio4"
                                containerClass="mr-5"
                                />
                                 <MDBInput
                                gap
                                onClick={this.onClick2(5)}
                                checked={this.state.numday === 5 ? true : false}
                                label="5 วัน"
                                type="radio"
                                id="radio5"
                                containerClass="mr-5"
                                />
                            </MDBFormInline>
                        
                        
                        </>}
                      

                        <div className="mb-2">
                        <label className="font-weight-bold"><MDBIcon icon="donate" /> มัดจำกุญแจ</label>
                             <MDBFormInline>
                                <MDBInput
                                gap
                                onClick={this.Depositkey(100)}
                                checked={this.state.Depositkey === 100 ? true : false}
                                label="มัดจำกุญแจ"
                                type="radio"
                                id="radio3"
                                containerClass="mr-5"
                                />
                               
                            </MDBFormInline>
                        </div>
                        <div className="mb-2">
                                      <label className="font-weight-bold"><MDBIcon icon="donate" /> เบอร์โทร</label>
                                      <input className="form-control" onChange={this.onTextChange} name="tel"
                                          value={this.state.tel}  placeholder=""  />
                        </div>

                        {/* <div className="mb-2">
                                      <label className="font-weight-bold"><MDBIcon icon="donate" /> เบอร์โทร</label>
                                      <input type='file' className="form-control" onChange={this.handleChange3} name="sdf"
                                          value={this.state.sdf}  placeholder=""  />
                        </div> */}
                       

                    </MDBCardBody>
              </MDBCol>
              <MDBCol md="6" >
                <br/>
                {this.state.confirm === true ?<>
                     
                      <div className="mb-2">
                      <label className="font-weight-bold"><MDBIcon icon="donate" /> ภาพบัตรประชาชน</label>
                          <div className='text-center'>
                          <img src={this.state.url} alt="Screenshot" />
                          </div>
                      </div>
                       <h5 className='text-center'>ยืนยันแล้ว</h5>
                </>:<>
                <div className="mb-2">
                <label className="font-weight-bold"><MDBIcon icon="donate" /> ภาพบัตรประชาชน</label>
                    <Camera />
                    <div className='text-center'>
                      
                    {this.state.url && (
                        <div>
                         
                          <img src={this.state.url} alt="Screenshot" />
                           <MDBBtn  color="unique" className="text-center" onClick={this.getencode}> <MDBIcon far icon="save" /> ยืนยัน</MDBBtn>
                        </div>
                      )}
                     
                    </div> 
                  </div>
                </>}
                
                
              </MDBCol>
              
            </MDBRow>
        <MDBBtn className='text-center' color="dark-green"><h3 className="white-text" onClick={this.handleSubmitroom}>บันทึก</h3></MDBBtn>  
        </MDBCard>
        
        </MDBCol>
            
      <br/>
      
      </MDBContainer>           
                          </MDBContainer>
    )
  }
}
